import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgCo2Sensor = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      d="M34 10.98H6V12h28z"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M34 11V8.86A1.86 1.86 0 0 0 32.14 7H7.86A1.86 1.86 0 0 0 6 8.86V11zM6 12v21h18.1a9.9 9.9 0 0 0 9.9-9.9V12z"
      clipRule="evenodd"
    />
    <path
      fill="#FFBFA5"
      d="M10 13.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4M25.17 29.51a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M25.17 23.01a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-2.5 1.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgCo2Sensor);

export default ForwardRef;
